export default __webpack_public_path__ + "static/media/argentina.1d505671.png";